import React from 'react';
import { ShieldX, LogOut } from 'lucide-react';
import { isEntraAuth, msalInstance } from '../auth/authConfig';
import wmLogo from '../assets/logos/WM-Logo-CB-White-Header.png';

const AccessDeniedPage = () => {
  const handleSignOut = () => {
    if (isEntraAuth() && msalInstance) {
      msalInstance.logoutRedirect();
      return;
    }
    localStorage.removeItem('pmd-identity');
    localStorage.removeItem('pmd-impersonated-user');
    window.location.href = '/';
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#1a5568', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="auth-gate-card">

        {/* Branded header — matches auth gate */}
        <div className="auth-gate-header">
          <img src={wmLogo} alt="Wunderlich-Malec" className="auth-gate-logo" />
          <div className="auth-gate-header-divider" />
          <div>
            <div className="auth-gate-title">DAWN</div>
            <div className="auth-gate-subtitle">DOCUMENTATION · ASSETS · WIRING · NETWORKING</div>
          </div>
        </div>

        {/* Content */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', textAlign: 'center' }}>
          <ShieldX size={52} style={{ color: '#dc2626', marginBottom: '1.25rem' }} />
          <h1 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.75rem', color: '#1e293b', margin: '0 0 0.75rem' }}>
            Access Denied
          </h1>
          <p style={{ color: '#64748b', lineHeight: 1.6, marginBottom: '2rem', fontSize: '0.875rem', margin: '0 0 2rem' }}>
            You've authenticated successfully, but you don't have an account in DAWN.
            Contact an administrator to request access.
          </p>
          <button
            onClick={handleSignOut}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.625rem 1.25rem',
              background: '#1a5568',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '0.875rem',
              fontWeight: 500,
              cursor: 'pointer'
            }}
          >
            <LogOut size={16} />
            Sign Out
          </button>
        </div>

      </div>
    </div>
  );
};

export default AccessDeniedPage;
